export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Appliquer vos points à votre achat',
        modalSubTitle: `Vous avez actuellement <b>${vars[0]}</b> points`,
        chooseText: 'Veuillez choisir une réponse :',
        biCashAmount: `<b>${vars[0]}</b> Dollars Beauty Insider`,
        pointsAmount: `${vars[0]} points`,
        apply: 'Appliquer',
        applied: 'Appliqué',
        remove: 'Supprimer',
        subtotal: 'Sous-total de la commande',
        pointsAppliedLegal: 'Les points échangés contre des dollars Beauty Insider ne sont pas remboursables.',
        done: 'Terminé',
        emptyBasketError: 'Les marchandises, à l’exception des cartes-cadeaux, doivent être incluses dans votre commande pour bénéficier de cette offre.',
        biCashSubtotalError: 'Vos points appliqués ne peuvent pas dépasser le sous-total de la commande admissible. Pour appliquer des points à votre achat, veuillez vérifier que le sous-total de la commande admissible est supérieur à la valeur des points que vous voulez appliquer.'
    };

    return resources[label];
}
